<mat-form-field class="years-selector" appearance="outline">
  <mat-label>{{ 'Année' }}</mat-label>
  <mat-select
    [(ngModel)]="selectedYear"
    [disabled]="!availableYears || availableYears.length === 0"
  >
    @for (year of years; track $index) {
    <mat-option [value]="year">
      {{ year }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
